// extracted by mini-css-extract-plugin
export default {"box":"image-with-auth_box__zRdA0","download":"image-with-auth_download__+BL3W","downloadIcon":"image-with-auth_downloadIcon__m1tvp"};